<template>
    <vue-final-modal
        @opened="opened"
        v-bind="$attrs"
        v-slot="{ close }"
        :esc-to-close="true"
    >
        <div class="opui-modal opui-modal-workflow-duplicate" @click="$events.emit('clickedOutside')">
            <div class="opui-modal-dialog opui-mw-900">
                <div class="opui-modal-content">
                    <div class="opui-modal-header">
                        <h1>
                            {{ $e('Duplicate Workflow') }}
                        </h1>
                        <i @click.prevent="close" class="opui-icon-close opui-modal-close"></i>
                    </div>

                    <div class="opui-modal-body">
                        <form class="opui-form" @submit.prevent="save" method="post">
                            <div class="opui-form-group">
                                <label class="opui-form-label-top">{{ $e('Workflow Title') }}</label>
                                <input type="text"
                                       v-model="newTitle"
                                       class="opui-form-control"
                                       autofocus
                                       required
                                />
                                <p class="opui-form-text">{{ $e('Set a title for your workflow.') }}</p>
                            </div>

                            <div class="opui-form-actions opui-justify-content-between opui-flex">
                                <button type="button" class="opui-btn opui-btn-outline-secondary opui-px-6" @click.prevent="closeAllModals">{{ $e('Cancel') }}</button>

                                <button type="submit" class="opui-btn opui-btn-primary" :class="{ saving: saving, disabled: saving, 'opui-disabled': saving }" :disabled="saving">
                                    <span class="opui-spinner opui-spinner-border opui-text-light opui-mr-2"></span>
                                    <span class="opui-btn-saving-label">{{ $e('Saving...') }}</span>
                                    <span class="opui-btn-label">{{ $e('Duplicate Workflow') }}</span>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>
export default {
    props: {
        workflow: { type: Object, required: true },
    },
    data() {
        return {
            newTitle: 'Copy of: ' + this.workflow.title,
            saving: false
        }
    },
    methods: {
        /**
         * Save workflow
         * @returns {Promise<Object>}
         */
        async save() {
            this.saving = true

            let response = await this.$http.post('workflows/' + this.workflow.id + '/duplicate', {
                title:         this.newTitle,
            });
            let status   = response.status

            if (status === 200) {
                this.$emit('duplicated', response.data.data)
                this.$toast.success('Workflow duplicated.')
            } else {
                console.info('Error when duplicating workflow.', response.data)
            }
            this.closeAllModals()
            this.saving = false

            return this.workflow
        },
    }
}
</script>
